import React from 'react';
import { Tab, Tabs } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useStyles } from './AppTabs.styles';
import theme from '../../../styles/theme';

interface TabConfig {
  label: string;
  path: string;
  itemsCount?: number;
}

interface AppTabsProps {
  config: TabConfig[];
  children?: React.ReactNode;
}

const AppTabs: React.FC<AppTabsProps> = (props) => {
  const { config, children } = props;
  const location = useLocation();
  const currentPath = location.pathname.toLowerCase().replace(/\/+$/, '');
  const normalizedCurrentPath = currentPath || '/';
  const normalizedTabPaths = config.map((tab) => ({
    ...tab,
    normalizedPath: tab.path.toLowerCase().replace(/\/+$/, '') || '/',
  }));
  const activeTabValue =
    normalizedTabPaths
      .filter(
        ({ normalizedPath }) =>
          normalizedCurrentPath === normalizedPath ||
          normalizedCurrentPath.startsWith(`${normalizedPath}/`),
      )
      .sort((a, b) => b.normalizedPath.length - a.normalizedPath.length)[0]
      ?.normalizedPath ?? false;
  const { classes } = useStyles(theme);

  return (
    <div className={classes.wrapper}>
      <Tabs
        classes={{ root: classes.tabs, scroller: classes.tabsScroller }}
        value={activeTabValue}>
        {normalizedTabPaths.map(
          ({ label, path, itemsCount, normalizedPath }) => (
            <Tab
              key={path}
              component={NavLink}
              to={path}
              value={normalizedPath}
              classes={{ selected: classes.selectedTab, root: classes.tabRoot }}
              label={
                <div className={clsx(classes.tab)}>
                  <span>{label}</span>
                  {typeof itemsCount === 'number' && (
                    <span className={classes.itemsCount}>{itemsCount}</span>
                  )}
                </div>
              }
            />
          ),
        )}
      </Tabs>
      {children}
    </div>
  );
};

export default AppTabs;
